import React, { useState, useEffect } from 'react';
import './BrowserCompatibility.css';

const BrowserCompatibility = () => {
  const [showWarning, setShowWarning] = useState(false);
  const [browserName, setBrowserName] = useState('');

  useEffect(() => {
    const detectBrowser = () => {
      const userAgent = navigator.userAgent.toLowerCase();
      let browser = 'Unknown';
      
      if (userAgent.includes('chrome') && !userAgent.includes('edg')) {
        browser = 'Chrome';
      } else if (userAgent.includes('firefox')) {
        browser = 'Firefox';
      } else if (userAgent.includes('safari') && !userAgent.includes('chrome')) {
        browser = 'Safari';
      } else if (userAgent.includes('edg')) {
        browser = 'Edge';
      } else if (userAgent.includes('msie') || userAgent.includes('trident')) {
        browser = 'Internet Explorer';
      }
      
      setBrowserName(browser);
      
      // Show warning if not Chrome
      if (browser !== 'Chrome') {
        setShowWarning(true);
      }
    };
    
    detectBrowser();
  }, []);

  const handleDismiss = () => {
    setShowWarning(false);
    // Store dismissal in sessionStorage so it doesn't show again this session
    sessionStorage.setItem('browser_warning_dismissed', 'true');
  };

  // Check if user has already dismissed the warning
  useEffect(() => {
    const dismissed = sessionStorage.getItem('browser_warning_dismissed');
    if (dismissed === 'true') {
      setShowWarning(false);
    }
  }, []);

  if (!showWarning) return null;

  return (
    <div className="browser-warning-overlay">
      <div className="browser-warning-card">
        <div className="browser-warning-header">
          <span className="warning-icon">⚠️</span>
          <h2>Browser Compatibility Notice</h2>
        </div>
        
        <div className="browser-warning-content">
          <p>
            You are currently using <strong>{browserName}</strong>. 
            For the best experience with our application, we recommend using <strong>Google Chrome</strong>.
          </p>
          
          <div className="browser-warning-reasons">
            <h3>Why Chrome?</h3>
            <ul>
              <li>✅ Full screen capture functionality</li>
              <li>✅ Better WebSocket performance</li>
              <li>✅ Optimal OCR processing</li>
              <li>✅ Enhanced security features</li>
            </ul>
          </div>
          
          <div className="browser-warning-actions">
            <a 
              href="https://www.google.com/chrome/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="btn-download-chrome"
            >
              Download Google Chrome
            </a>
            <button 
              onClick={handleDismiss}
              className="btn-continue-anyway app-btn"
            >
              Continue Anyway
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BrowserCompatibility;

